import { notices } from "@/mocks/home";

export default function NoticeBar() {
  const loop = [...notices, ...notices];
  return (
    <div className="relative overflow-hidden bg-secondary-950">
      <div className="mx-auto flex h-10 max-w-full items-center px-4 md:px-6">
        <span className="z-10 mr-4 hidden shrink-0 items-center gap-1.5 font-label text-xs font-medium text-accent-300 sm:flex">
          <i className="ri-megaphone-line w-4 h-4 flex items-center justify-center"></i>
          运营公告
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="anim-marquee flex w-max items-center gap-10 whitespace-nowrap">
            {loop.map((text, index) => (
              <span
                key={`${index}-${text}`}
                className="flex items-center gap-2 font-label text-xs text-background-100/85"
              >
                <i className="ri-flashlight-line w-3.5 h-3.5 flex items-center justify-center text-accent-400"></i>
                {text}
              </span>
            ))}
          </div>
        </div>
        <a
          href="#archive"
          className="z-10 ml-4 hidden shrink-0 items-center gap-1 font-label text-xs font-medium text-accent-300 hover:text-accent-200 md:flex"
        >
          全部公告
          <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center"></i>
        </a>
      </div>
    </div>
  );
}